document.addEventListener('DOMContentLoaded', function () {
        cropText();
        get_bike_label();
      });

      
function cropText() {
    const cropTextElements = document.querySelectorAll('.cropText');

    cropTextElements.forEach(element => {
        const maxLength = parseInt(element.getAttribute('data-maxlength')) || 150;
        const cta = element.getAttribute('data-cta') || '[...]';
        const shortTextElement = element.previousElementSibling;
        if (!shortTextElement || !shortTextElement.classList.contains('shortText')) return;

        const fullText = element.textContent.trim();
        if (!fullText || fullText.length <= maxLength) {
            element.style.display = 'block';
            shortTextElement.style.display = 'none';
            return;
        }

        const croppedText = fullText.substring(0, maxLength);
        shortTextElement.textContent = croppedText;

        const readMoreLink = document.createElement('a');
        readMoreLink.href = '#';
        readMoreLink.innerHTML = '<br><br>'+cta;
        readMoreLink.className = element.getAttribute('data-class') || '';

        shortTextElement.appendChild(readMoreLink);
        element.style.display = 'none';

        readMoreLink.addEventListener('click', (event) => {
            event.preventDefault();
            element.style.display = 'block';
            shortTextElement.style.display = 'none';
        });
    });
}

function get_bike_label() {

    document.querySelectorAll('.pi_close_box').forEach(element => {
        element.addEventListener('click', () => {
            const container = document.getElementById('pi_container');
            if (container) {
                container.style.display = 'none';
            }
        });
    });

    document.querySelectorAll('.pi_my_bike').forEach(element => {
        element.addEventListener('click', () => {
            const container = document.getElementById('pi_container');
            if (container) {
                container.style.display = 'table';
            }
        });
    });

    document.querySelectorAll('a[href*="#selector"]').forEach(element => {
    element.addEventListener('click', () => {
        const container = document.getElementById('pi_container');
        if (container) {
            container.style.display = 'table';
        }
        });
    });

    const myBikeDiv = document.querySelector('.pi_my_bike');
    const lang = myBikeDiv.getAttribute('data-lang');
const labelElements = document.querySelectorAll('.pi_my_bike_label');
let labelText = lang === 'fr' ? 'MA MOTO' : 'MY BIKE';
const make = localStorage.getItem('make');
const model = localStorage.getItem('model');
const year = localStorage.getItem('year');
if (make && model && year) {
    labelText = `${make}, ${model}, ${year}`;
}
labelElements.forEach(element => {
    element.textContent = labelText;
});
}


    const jsonUrl = document.getElementById('pi_moto_chart').value;
    let motos = [];

    // Charger les données JSON
    fetch(jsonUrl)
        .then(response => {
            if (!response.ok) throw new Error('Erreur de chargement du JSON');
            return response.json();
        })
        .then(data => {
            motos = data;
            populateMakes();
            loadFromLocalStorage(); // Charger les valeurs depuis localStorage après le chargement des données
        })
        .catch(error => console.error('Erreur:', error));

    function populateMakes() {
        const makeSelect = document.getElementById('pi_makeSelect');
        const makes = [...new Set(motos.map(moto => moto.MAKE))]
            .filter(make => make && make.trim() !== '')
            .sort();

        makes.forEach(make => {
            const option = document.createElement('option');
            option.value = make;
            option.textContent = make;
            makeSelect.appendChild(option);
        });

        // Ajouter les écouteurs d'événements une seule fois
        makeSelect.addEventListener('change', populateModels);
        document.getElementById('pi_modelSelect').addEventListener('change', populateYears);
        document.getElementById('pi_yearSelect').addEventListener('change', toggleSubmitButton);
    }

    function populateModels() {
        const makeSelect = document.getElementById('pi_makeSelect');
        const modelSelect = document.getElementById('pi_modelSelect');
        const yearSelect = document.getElementById('pi_yearSelect');
        const submitButton = document.getElementById('pi_submitButton');
        const saveButton = document.getElementById('pi_saveButton');
        const resetButton = document.getElementById('pi_resetButton');

        // Réinitialiser les sélecteurs et masquer les éléments
        modelSelect.innerHTML = '<option value="">Sélectionner un modèle</option>';
        yearSelect.innerHTML = '<option value="">Sélectionner une année</option>';
        modelSelect.style.display = 'none';
        yearSelect.style.display = 'none';
        submitButton.style.display = 'none';
        saveButton.style.display = 'none';
        resetButton.style.display = 'block'; // Afficher le bouton Reset dès qu'une marque est sélectionnée

        if (makeSelect.value) {
            const models = [...new Set(motos
                .filter(moto => moto.MAKE === makeSelect.value)
                .map(moto => moto.MODEL)
            )].filter(model => model && model.trim() !== '').sort();

            models.forEach(model => {
                const option = document.createElement('option');
                option.value = model;
                option.textContent = model;
                modelSelect.appendChild(option);
            });

            // Afficher le sélecteur de modèle si des modèles sont disponibles
            modelSelect.style.display = models.length > 0 ? 'block' : 'none';

            // Débogage
            console.log(`Modèles pour ${makeSelect.value}:`, models);
        }
    }

    function populateYears() {
        const makeSelect = document.getElementById('pi_makeSelect');
        const modelSelect = document.getElementById('pi_modelSelect');
        const yearSelect = document.getElementById('pi_yearSelect');
        const submitButton = document.getElementById('pi_submitButton');
        const saveButton = document.getElementById('pi_saveButton');
        const resetButton = document.getElementById('pi_resetButton');

        // Réinitialiser le sélecteur d'années et masquer les boutons
        yearSelect.innerHTML = '<option value="">Sélectionner une année</option>';
        yearSelect.style.display = 'none';
        submitButton.style.display = 'none';
        saveButton.style.display = 'none';
        resetButton.style.display = 'block'; // Garder le bouton Reset visible

        if (makeSelect.value && modelSelect.value) {
            const years = [...new Set(motos
                .filter(moto => moto.MAKE === makeSelect.value && moto.MODEL === modelSelect.value)
                .map(moto => moto.YEAR)
            )].filter(year => year && year.toString().trim() !== '').sort((a, b) => b - a);

            years.forEach(year => {
                const option = document.createElement('option');
                option.value = year;
                option.textContent = year;
                yearSelect.appendChild(option);
            });

            // Afficher le sélecteur d'années si des années sont disponibles
            yearSelect.style.display = years.length > 0 ? 'block' : 'none';

            // Débogage
            console.log(`Années pour ${makeSelect.value} ${modelSelect.value}:`, years);
        }
    }

    function toggleSubmitButton() {
        const yearSelect = document.getElementById('pi_yearSelect');
        const submitButton = document.getElementById('pi_submitButton');
        const saveButton = document.getElementById('pi_saveButton');
        const resetButton = document.getElementById('pi_resetButton');

        // Afficher les boutons "VOIR" et "SAUVEGARDER" uniquement si une année est sélectionnée
        submitButton.style.display = yearSelect.value ? 'block' : 'none';
        saveButton.style.display = yearSelect.value ? 'block' : 'none';
        resetButton.style.display = 'block'; // Garder le bouton Reset visible
    }

    function saveToLocalStorage() {
        const makeSelect = document.getElementById('pi_makeSelect');
        const modelSelect = document.getElementById('pi_modelSelect');
        const yearSelect = document.getElementById('pi_yearSelect');
        const container = document.getElementById('pi_container');

        if (makeSelect.value && modelSelect.value && yearSelect.value) {
            const moto = motos.find(m => 
                m.MAKE === makeSelect.value && 
                m.MODEL === modelSelect.value && 
                m.YEAR === yearSelect.value
            );

            if (moto && moto.COLLECTION) {
                const collection = moto.COLLECTION.split('$')[0].trim();
                // Enregistrer dans localStorage
                localStorage.setItem('make', makeSelect.value);
                localStorage.setItem('model', modelSelect.value);
                localStorage.setItem('year', yearSelect.value);
                localStorage.setItem('collection', collection);
                get_bike_label();
                // Masquer le conteneur
                container.style.display = 'none';
            }
        }
    }

    function loadFromLocalStorage() {
        const makeSelect = document.getElementById('pi_makeSelect');
        const modelSelect = document.getElementById('pi_modelSelect');
        const yearSelect = document.getElementById('pi_yearSelect');
        const submitButton = document.getElementById('pi_submitButton');
        const saveButton = document.getElementById('pi_saveButton');
        const resetButton = document.getElementById('pi_resetButton');

        const savedMake = localStorage.getItem('make');
        const savedModel = localStorage.getItem('model');
        const savedYear = localStorage.getItem('year');

        if (savedMake) {
            makeSelect.value = savedMake;
            populateModels(); // Remplir les modèles

            if (savedModel) {
                modelSelect.value = savedModel;
                populateYears(); // Remplir les années

                if (savedYear) {
                    yearSelect.value = savedYear;
                    toggleSubmitButton(); // Afficher les boutons si une année est sélectionnée
                }
            }
        }

        // Afficher le bouton Reset si des données sont dans localStorage
        if (savedMake || savedModel || savedYear) {
            resetButton.style.display = 'block';
        }
    }

    function resetForm() {
        const makeSelect = document.getElementById('pi_makeSelect');
        const modelSelect = document.getElementById('pi_modelSelect');
        const yearSelect = document.getElementById('pi_yearSelect');
        const submitButton = document.getElementById('pi_submitButton');
        const saveButton = document.getElementById('pi_saveButton');
        const resetButton = document.getElementById('pi_resetButton');
        const resultDiv = document.getElementById('result');
        const container = document.getElementById('pi_container');

        // Supprimer les données de localStorage
        localStorage.removeItem('make');
        localStorage.removeItem('model');
        localStorage.removeItem('year');
        localStorage.removeItem('collection');
        get_bike_label();
        // Réinitialiser les sélecteurs
        makeSelect.value = '';
        modelSelect.innerHTML = '<option value="">Sélectionner un modèle</option>';
        yearSelect.innerHTML = '<option value="">Sélectionner une année</option>';
        modelSelect.style.display = 'none';
        yearSelect.style.display = 'none';
        submitButton.style.display = 'none';
        saveButton.style.display = 'none';
        resetButton.style.display = 'none';
        resultDiv.style.display = 'none';
        container.style.display = 'table'; // Réafficher le conteneur
    }

    function filterCollection() {
        const makeSelect = document.getElementById('pi_makeSelect');
        const modelSelect = document.getElementById('pi_modelSelect');
        const yearSelect = document.getElementById('pi_yearSelect');

        if (makeSelect.value && modelSelect.value && yearSelect.value) {
            const moto = motos.find(m => 
                m.MAKE === makeSelect.value && 
                m.MODEL === modelSelect.value && 
                m.YEAR === yearSelect.value
            );

            if (moto && moto.COLLECTION) {
                const collection = moto.COLLECTION.split('$')[0].trim();
                // Enregistrer dans localStorage
                localStorage.setItem('make', makeSelect.value);
                localStorage.setItem('model', modelSelect.value);
                localStorage.setItem('year', yearSelect.value);
                localStorage.setItem('collection', collection);
                // Rediriger vers l'URL
                //window.location.href = `https://motomotto.ca/${collection}`;
                window.location.href = `${collection}?sort_by=manual`;
            } else {
                const resultDiv = document.getElementById('result');
                resultDiv.style.display = 'block';
                resultDiv.textContent = 'Aucun résultat trouvé';
            }
        }
    }